export default __webpack_public_path__ + "static/image03-6753f6060da76af7d20ff29ef99da995.png";